import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback } from 'react';
import { useFeatureFlag } from '@atlassian/notification-common';
import { useExperienceTracker } from '@atlassian/notification-common/experience-tracking';
import { AbortReason, Experiences, RequestReadState } from '@atlassian/notification-common/types';
import { useNotificationActions } from '../../../use-notification-list-store/store';
import { saveReadStateFilterToLocalStorage } from '../../../utils/local-storage-util';
import { useNotificationStateFilters } from '../../store';
var useNotificationListFilterActions = function useNotificationListFilterActions() {
  var experienceTracker = useExperienceTracker();
  var isGroupingEnabled = useFeatureFlag('enableGrouping', false);
  var _useNotificationState = useNotificationStateFilters(),
    _useNotificationState2 = _slicedToArray(_useNotificationState, 2),
    filters = _useNotificationState2[0],
    actions = _useNotificationState2[1];
  var _useNotificationActio = useNotificationActions(),
    _useNotificationActio2 = _slicedToArray(_useNotificationActio, 2),
    updateFilterState = _useNotificationActio2[1].updateFilterState;
  var resetNotificationListFiltersStore = actions.resetNotificationListFiltersStore,
    setReadStateFilter = actions.setReadStateFilter,
    setCategoryFilter = actions.setCategoryFilter,
    setProductFilter = actions.setProductFilter;
  var abortNotificationExperiences = useCallback(function () {
    experienceTracker.abort({
      name: Experiences.RENDER_NOTIFICATIONS_WITHOUT_CONTENT,
      reason: AbortReason.CHANGE_FILTER
    });
    experienceTracker.abort({
      name: Experiences.RENDER_NOTIFICATIONS_WITH_CONTENT,
      reason: AbortReason.CHANGE_FILTER
    });
  }, [experienceTracker]);

  // Callbacks
  var toggleReadStateFilter = useCallback(function () {
    var newReadStateFilter = function () {
      if (filters.readStateFilter === RequestReadState.ANY) {
        saveReadStateFilterToLocalStorage(RequestReadState.UNREAD);
        return RequestReadState.UNREAD;
      } else {
        saveReadStateFilterToLocalStorage(RequestReadState.ANY);
        return RequestReadState.ANY;
      }
    }();
    abortNotificationExperiences();
    setReadStateFilter(newReadStateFilter);
    updateFilterState(filters, isGroupingEnabled);
  }, [abortNotificationExperiences, setReadStateFilter, updateFilterState, filters, isGroupingEnabled]);
  var handleSetCategoryFilter = useCallback(function (requestCategory) {
    abortNotificationExperiences();
    setCategoryFilter(requestCategory);
    updateFilterState(filters, isGroupingEnabled);
  }, [abortNotificationExperiences, filters, setCategoryFilter, updateFilterState, isGroupingEnabled]);
  var handleSetProductFilter = useCallback(function (product) {
    abortNotificationExperiences();
    setProductFilter(product);
    updateFilterState(filters, isGroupingEnabled);
  }, [abortNotificationExperiences, filters, setProductFilter, updateFilterState, isGroupingEnabled]);
  return {
    filters: filters,
    toggleReadStateFilter: toggleReadStateFilter,
    handleSetCategoryFilter: handleSetCategoryFilter,
    handleSetProductFilter: handleSetProductFilter,
    resetNotificationListFiltersStore: resetNotificationListFiltersStore
  };
};
export default useNotificationListFilterActions;